/* eslint-disable max-len */
import React from 'react';

const LayoutColumnsIcon = props => (
  <svg width={50} height={50} viewBox="0 0 50 50" {...props}>
    <path
      fillRule="evenodd"
      fill="currentColor"
      d="M3 2h11a1 1 0 0 1 1 1v44a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v44h11V3H3zm15-1h14a1 1 0 0 1 1 1v44a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v44h14V3H18zm18-1h11a1 1 0 0 1 1 1v44a1 1 0 0 1-1 1H36a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v44h11V3H36z"
    />
  </svg>
);

export default LayoutColumnsIcon;
